import React, { FC, PropsWithChildren, createContext, useContext, useMemo, useState } from 'react'

export interface ProductCardHoverContext {
  isHovered: boolean
  setHovered: React.Dispatch<React.SetStateAction<boolean>>
}
const productCardHoverContext = createContext<ProductCardHoverContext | null>(null)

export const ProductCardHoverProvider: FC<PropsWithChildren<Record<string, never>>> = ({ children }) => {
  const [isHovered, setHovered] = useState(false)
  const value = useMemo(
    () => ({
      isHovered,
      setHovered,
    }),
    [isHovered],
  )
  return <productCardHoverContext.Provider value={value}>{children}</productCardHoverContext.Provider>
}

export function useProductCardHover() {
  const ctx = useContext(productCardHoverContext)
  if (!ctx) {
    // @i18n-ignore
    throw new Error('useProductCardHover can be used only inside ProductCardHoverProvider')
  }
  return ctx
}
